import React from 'react';
export const PackagePickerLoadingContext = /*#__PURE__*/React.createContext({});
export const PackagePickerLoadingProvider = _ref => {
  let {
    children,
    callbacks
  } = _ref;
  return /*#__PURE__*/React.createElement(PackagePickerLoadingContext.Provider, {
    value: {
      ...callbacks
    }
  }, children);
};
export const useLoadingContext = () => {
  const {
    onInit,
    onLoad,
    onError
  } = React.useContext(PackagePickerLoadingContext);
  return {
    onInit,
    onLoad,
    onError
  };
};
//# sourceMappingURL=PackagePickerLoadingProvider.js.map